import { useGlobal } from "@/context/GlobalContext";

export const Money = ({ usd: amount, decimals, testid, approxClassName = "text-xs text-slate-400 font-mono", inline = false }) => {
  const { usd, approx } = useGlobal();
  const est = approx(amount, decimals);
  return (
    <span data-testid={testid} className={inline ? "inline-flex items-baseline gap-1.5" : "inline-flex flex-col"}>
      <span>{usd(amount, decimals)}</span>
      {est && <span data-testid={testid ? `${testid}-approx` : undefined} className={approxClassName}>{est}</span>}
    </span>
  );
};
